import { SelectionChangedEvent } from "ag-grid-community";
import { QuotationEntity } from "domain/entity/QuotationSetting/QuotationEntity";
import { INITIAL_QUOTATION_COL_DEF, transferRowData } from "presentation/constant/QuotationSetting/QuotationColumnDefinition";
import { QuotationConstant } from "presentation/constant/QuotationSetting/QuotationConstant";
import { useQuotationVM } from "presentation/hook/QuotationSetting/useQuotationVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useQuotationTracked } from "presentation/store/QuotationSetting/QuotationProvider";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useMemo, useRef } from "react";

const QuotationTablePanel: React.FC = () => {
    const [quotationState] = useQuotationTracked();
    const quotationVM = useQuotationVM();
    const { quotationList } = quotationState;
    const gridRef: any = useRef(null);
    const [anaInfoState] = useANAInfoTracked();
    const { allowCreate } = anaInfoState;

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        const selectedRows = e.api.getSelectedRows();
        quotationVM.updateSelectedRows(selectedRows);
    }, [quotationVM])

    const handleRowDoubleClick = useCallback((entity: QuotationEntity) => {
        quotationVM.onRowDoubleClick(entity);
    }, [quotationVM])

    const handleAdd = useCallback(() => {
        quotationVM.onAddClick();
    }, [quotationVM]);

    const memoTable = useMemo(() => {
        return (
            <NbisTable
                id='quotation-table'
                isNewColumnSetting={true}
                headerLabel={QuotationConstant.TITLE}
                columns={INITIAL_QUOTATION_COL_DEF}
                data={transferRowData(quotationList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={allowCreate}
                onAddClick={handleAdd}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                onRowDoubleClick={(e: any, entity: QuotationEntity) => handleRowDoubleClick(entity)}
                gridHeight="customHeight"
                customHeight="calc(100vh - 75px)"
                ref={gridRef}
            />
        );
    }, [allowCreate, handleAdd, handleRowDoubleClick, handleSelectionChange, quotationList])

    return <><TableWrapper>
        {memoTable}
    </TableWrapper>
    </>;
}

export default memo(QuotationTablePanel);
